// JavaScript Document
//components/configuration/ph5/setting/Form.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/AddCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/Save';
//import DeleteIcon from '@material-ui/icons/Delete';
import DeleteButton from '../../../core/DeleteButton';
import Utils from '../Utils';
import Field from './Field';

//import ImagePicker from '../forms/ImagePicker';
//import TextArea from '@material-ui/core/TextareaAutosize';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';
const utils = Utils();

const useStyles = makeStyles((theme) => ({
	formCard : {
		//margin: theme.spacing(1),
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
	detailsVerticalCenter: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-around",
		flexGrow: 1,
		flexDirection: "column",
		flexWrap: "wrap",
	},
	detailsHorizontal : {
		display: "flex",
		flexGrow:1,
		alignItems:"stretch",
		justifyContent:"space-between",
		flexWrap:"wrap",
		flexDirection:"row",
		width: "100%"
	},
	choiceInput : {
		minWidth : 100,
		maxWidth : 300,
		marginRight: 10,
	},
	input75 : {
		minWidth : 100,
		maxWidth: 300
	},
	input25 : {
		minWidth: 10,
		maxWidth: 30
	},
	sizeInput : {
		minWidth: 50,
		maxWidth: 200,
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  },
	optionTable: {
    minWidth: 300,
	maxHeight:'calc(100vh - 130px)',
	//maxHeight: '100%'
  },
}));

export default function OptionForm(props) {
  	const classes = useStyles();
	//inherited variables
  	const {handleSend, item, onChange} = props;
	//locally stored/copied variables
	const [isNew, setIsNew] = React.useState(false);
	const [changed, setChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save');
	const [choices, setChoices] = React.useState([]);
	const [controls, setControls] = React.useState({});

	const [choicePop, setChoicePop] = React.useState({
		anchor: null,
		item: -1,
		name: '',
		value: ''
	});
	const choicePopOpen = Boolean(choicePop.anchor);
	const [details, setDetails] = React.useState({
		id: 0,
		name: '', //name in configuration file
		description: '', //display name
		setting_ref: '', //reference to native setting
		options: '', //serialized picklist string
		sort: 0,	//sort order
		default_value: '', 
		input_description: '', //description tooltip for input
		data_type: 'string', //data type
		input_control: 'text',
		control_setup: {}
	});
	
	//utils.controls
	//utils.types
	//utils.native
	
	
	
	//local state varialbes user will change
	//Local constant for maximum value
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(!item.id){
			setIsNew(true);
		} else {
			setIsNew(false);
		}
		if(
			item.id 
			&& item.id !== details.id
		) {
			//console.log('config has changed');
			var newDetails = Object.assign({}, item);
			if(!newDetails.input_control){
				if(newDetails.setting_ref) {
					newDetails.input_control = 'native';
				} else if(newDetails.options){
					newDetails.input_control = 'picklist';
				} else {
					newDetails.input_control = 'text';
				}
				
			}
			if(newDetails.control_setup){
				let cs = newDetails.control_setup;
				if(typeof cs === 'string')
					cs = JSON.parse(cs);
				setControls(cs);
			}
			//if(newDetails.input_control === 'picklist'){
			//needs to zero out
			setChoices(utils.extractChoices(item.options));
			//}
			setDetails(newDetails);
			
		}
	}, [item, details.id]);
	
	React.useEffect(() => {
		var newDetails = Object.assign({}, details);
		newDetails.options = utils.compileChoices(choices);
		newDetails.control_setup = Object.assign({}, controls);
		setDetails(newDetails);
	}, [choices, controls, details])
	
	//utils.extractChoices
	const limits = {
		sort: 2147483647
	}
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, details);
		
		
		//if numeric
		if([
			'sort'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > limits[name]){
				value = limits[name];
			}
		}
		
		
		newDetails[name] = value;
		setDetails(newDetails);
		setChanged(true);
	}
	//handle change controls values
	const handleChangeControls = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let newControls = Object.assign({}, controls);
		
		if([
			'min', 'max', 'step'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value)){
				value = 0;
			} 
			if(name === 'step' && value < 1){
				value = 1;
			}
		}
		
		newControls[name] = value;
		setControls(newControls);
		setChanged(true);
	}
	
	const handleChangeChoice = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let newChoicePop = Object.assign({}, choicePop);
		newChoicePop[name] = value;
		setChoicePop(newChoicePop);
	}
	
	const handleCloseChoicePop = () => {
		setChoicePop({
			anchor: null,
			item : -1,
			name: '',
			value: ''
		});
	}
	
	//Handle save buttonclick
	const handleSave = (e) => {
		setSaveLabel('Saving');
		//var myDee
		//if(details.input_control === 'picklist')
			
		console.log("Save button clicked!");
		handleSend({
			vso: 'ph5_setting',
			ph5_setting: details,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setChanged(false);
			setSaveLabel('Save');
			//setConfig(data.config);
			setDetails(data.ph5_setting);
			//update parent if onChange is supplied
			if(onChange){
				onChange(data.ph5_setting, isNew);
			}
			setIsNew(false);
			
		});
	}
	//Handle update parent if onChange is provided
	/*
	const handleUpdateParent = (newTiming, newDim, newAlternate) => {
		if(onChange){
			console.log('Updating parent');
			onChange([newTiming.wigOn, newTiming.wigOff, newTiming.wagOn, newTiming.wagOff], newDim, newAlternate);
		}
	}
	*/
	
	//Final delete clicked
	const handleDelete = () => {
		setIsNew(true);
		handleSend({
			vso: 'ph5_setting',
			ph5_setting: details,
			subaction: 'delete'
		}, (data) => {
			setChanged(false);
			setIsNew(false);
			if(onChange){
				onChange(false);
			}
		})
	}
	

	
	//render card actions (save & Delete)
	const cardActions = () => {
		return (
			<ButtonGroup>
				{saveButton()}
				<DeleteButton onClick={handleDelete} visible={!isNew} />
			</ButtonGroup>
		)
	}
	

	const saveButton = () => {
		if(changed){
			return (
				<Button 
					variant="contained" 
					color="primary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return '';
	}
	
	const handleAddChoice = (e) => {
		//console.log("clicked add choice");
		setChoicePop({
			anchor: e.currentTarget,
			item: -1,
			name: '',
			value: ''
		})
	}
	const handleSelectChoice = (e, i) => {
		setChoicePop({
			anchor: e.currentTarget,
			item: i,
			name: choices[i].name,
			value: choices[i].value
		});
		//console.log(row);
	}
	
	const renderComboChoice = (name, description) => {
		return (
			<div>
				<Typography component="h3">{name}</Typography>
				<Typography component="h4">{description}</Typography>
			</div>
		)
	}
	
	const handleUpdateChoice = (e) => {
		var myChoices = Object.assign([], choices);
		var newChoice = {
			name: choicePop.name,
			value: choicePop.value
		}
		if(choicePop.item === -1) {
			myChoices.push(newChoice);
		} else {
			myChoices.splice(choicePop.item, 1, newChoice);
		}
		setChoices(myChoices);
		handleCloseChoicePop();
		setChanged(true);
	}
	
	const handleDeleteChoice = (e) => {
		handleCloseChoicePop();
		if(choicePop.item !== -1){
			var myChoices = Object.assign([], choices);
			myChoices.splice(choicePop.item, 1);
			setChoices(myChoices);
			setChanged(true);
		}
			
	}
	
	
	
	const renderChoices = () => {
		if(details.input_control === 'picklist')
			return (
			<Grid item xs={12}>
				<AppBar position="static" color="default">
					<Box display="flex" justifyContent="space-between">
						<Typography variant="h5">Dropdown Choices</Typography>
						<Button
							variant="contained"
							color="primary"
							onClick={handleAddChoice}
							startIcon={<AddIcon />}
						>Add Choice</Button>
					</Box>
				</AppBar>
				<TableContainer component={Paper} className={classes.optionTable}>
					<Table stickyHeader aria-label="Picklist Choices">
						<TableHead>
							<TableRow>
								<TableCell>Choice</TableCell>
								<TableCell>Value</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{choices.map((row, i) => (
							<TableRow hover role="checkbox" key={i} onClick={(e) => {handleSelectChoice(e, i)}}>
								<TableCell>{row.name}</TableCell>
								<TableCell>{row.value}</TableCell>
							</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<Popover
        			id="choicePopover"
        			open={choicePopOpen}
        			anchorEl={choicePop.anchor}
        			onClose={handleCloseChoicePop}
        			anchorOrigin={{
          				vertical: 'center',
          				horizontal: 'center',
        			}}
        			transformOrigin={{
          				vertical: 'center',
          				horizontal: 'center',
        			}}
      			>
        			<Box p={3}>
							<TextField
								id="choice_displayname"
								name="name"
								label="Choice"
								value={choicePop.name}
								type="text"
								onChange={handleChangeChoice}
								className={classes.choiceInput}
								autoFocus={true}
							/>
							<TextField
								id="choice_value"
								name="value"
								label="Value"
								value={choicePop.value}
								type="text"
								onChange={handleChangeChoice}
								className={classes.choiceInput}
								required
							/>
							<Button
								variant="contained"
								color="primary"
								onClick={handleUpdateChoice}
							>{choicePop.item === -1 ? "Add" : "Update"}</Button>
							<Button
								variant="contained"
								color="secondary"
								onClick={handleDeleteChoice}
							>{choicePop.item === -1 ? "Cancel" : "Remove"}</Button>
					</Box>
      			</Popover>
			</Grid>
			);
			/*
			return (
				<Grid item xs={12} sm={5}>
					<Typography component="h2">Dropdown Choices</Typography>
					{choices.map((choice, i) => (
					<MenuItem key={i}>
						{renderComboChoice(choice.name, choice.value)}
					</MenuItem>
					))}
					<Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddChoice}>Add Choice</Button>
				</Grid>
			);
			*/
		return '';
	}
	
	const renderNativeChoices = () => {
		if(details.input_control === 'native')
			return (
				<Tooltip title="Choose a native setting to populate this field" arrow>
							<TextField
								id="ph5_setting_ref"
								name="setting_ref"
								label="Native Setting"
								value={details.setting_ref}
								onChange={handleChangeValue}
								fullWidth
								select
							>
									{utils.native.map((opt, i) => (
									 <MenuItem key={i} value={opt.value}>{opt.name}</MenuItem>
									 ))}
							</TextField>
						</Tooltip>
			);
		return '';
	}
	const renderControlOptions = () => {
		if(details.input_control === 'picklist')
			return (
				<Grid item xs={12}>
					{renderChoices()}
				</Grid>
			);
		if(details.input_control === 'toggle')
			return (
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							id="switch_label_on"
							name="labelOn"
							label="On Label"
							required
							value={controls.labelOn}
							type="text"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							id="switch_label_off"
							name="labelOff"
							label="Off Label"
							required
							value={controls.labelOff}
							type="text"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							id="switch_value_on"
							name="valueOn"
							label="On Value"
							required
							value={controls.valueOn}
							type="text"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<TextField
							id="switch_value_off"
							name="valueOff"
							label="Off Value"
							required
							value={controls.valueOff}
							type="text"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
				</Grid>
				
			);
		if(details.input_control === 'number' || details.input_control === 'slider')
			return (
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
						<TextField
							id="number_min"
							name="min"
							label="Minimum Value"
							required
							value={!isNaN(controls.min) ? controls.min.toString() : "0"}
							type="number"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<TextField
							id="number_max"
							name="max"
							label="Maximum Value"
							required
							value={!isNaN(controls.max) ? controls.max.toString() : "255"}
							type="number"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<TextField
							id="number_step"
							name="step"
							label="Increment"
							required
							value={!isNaN(controls.step) ? controls.step.toString() : "5"}
							type="number"
							onChange={handleChangeControls}
							fullWidth
						/>
					</Grid>
				</Grid>
			);
		return '';
	}
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.formCard}>
			<CardHeader title={isNew ? 'New ITS Setting' : details.name} action={cardActions()}/>
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
						<Tooltip title="Name used in configuration file">
							<TextField
								id="ph5_name"
								name="name"
								label="Name"
								required
								value={details.name}
								type="text"
								inputProps = {{
									  maxlength:"50"
									 }}
								onChange={handleChangeValue}
								fullWidth
							/>
						</Tooltip>
						<TextField
							id="ph5_data_type"
							name="data_type"
							label="Data Type"
							value={details.data_type}
							fullWidth
							select 
							onChange={handleChangeValue}
						>
							{utils.types.map((dt, i) => (
							 <MenuItem key={i} value={dt.value}>{dt.name}</MenuItem>
							 ))}
						</TextField>
						<TextField
							id="ph5_sort"
							name="sort"
							label="Sort Order"
							value={details.sort.toString()}
							fullWidth
							type="number"
							inputProps = {{
								min: 0,
								max: limits.sort
							}}
							onChange={handleChangeValue}
						/>
						
						
					</Grid>
					<Grid item xs={12} sm={4}>
						<Tooltip title="Field name displayed to user">
							<TextField
								id="ph5_description"
								name="description"
								label="Display Name"
								multiline
								maxRows={4}
								value={details.description}
								onChange={handleChangeValue}
								fullWidth
								required
							/>
						</Tooltip>
						<TextField
							id="ph5_input_control"
							name="input_control"
							label="Input Control"
							value={details.input_control}
							fullWidth
							displayEmpty
							select 
							onChange={handleChangeValue}
						>
							{utils.controls.map((cnt, i) => (
							<MenuItem key={i} value={cnt.value}>
								 {renderComboChoice(cnt.name, cnt.description)}
							</MenuItem>
							 ))}
						</TextField>
					</Grid>
					<Grid item xs={12} sm={4}>
						<Tooltip title="Instructions displayed to the user" arrow>
							<TextField
								id="ph5_input_description"
								name="input_description"
								label="Input Description"
								value={details.input_description}
								multiline
								maxRows={4}
								onChange={handleChangeValue}
								fullWidth
							/>
						</Tooltip>
						{renderNativeChoices()}
						<Field
							id="ph5_def_val"
							name="default_value"
							label="Default Value"
							choices={choices}
							options={controls}
							control={details.input_control}
							value={details.default_value}
							onChange={handleChangeValue}
						/>
					</Grid>
				</Grid>
				{renderControlOptions()}
	  		</CardContent>
	  	</Card>
  );
}
